import React, {Component} from 'react';
import axios from 'axios';
import Breadcrumb from  '../../../components/Layout/Breadcrumb';
import ModalComponent from  '../../../components/ModalComponent';
import {FaCloud, FaSearch} from "react-icons/fa";
import {
    Button,
    Card,
    CardBody,
    DropdownItem,
    DropdownMenu,
    DropdownToggle, Input, InputGroup, InputGroupAddon,
    Table,
    UncontrolledButtonDropdown
} from 'reactstrap';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import PaginateComponent from "../../../components/PaginateComponent";
import ListProxyComponent from "../../../components/Admin/proxies/ListProxyComponent";
import {Link} from "react-router-dom";

class ListProxyByStatus extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            isLoading: true,
            listService: [],
            perPage: 0,
            totalPage: 0,
            currentPage: 0,
            error: false,
            messageError: '',
            isNotification: '',
            textNotification: '',
            isModal: false,
            titleModal: '',
            modalBody: '',
            action: '',
            isBtnConfirm: true,
            contentModal: '',
            btnConfirmDisabled: false,
            isSpinner: false,
            actionKey: 0,
            alert: {
                error: false,
                message: ''
            },
            userId: 0,
            typeOrder: '',
            qtt: 30,
            search: '',
            status: '',
            listStatus: {},
            btn_all: 'Chọn hành động',
            vpsUpdate: [],
            errorNotification: false,
            messageErrorNotification: '',
            successNotification: false,
            messageSuccessNotification: '',
            email: '',
            checkEmail: false,
            listUser: {},
            userChange: "",
            searchUser: '',
            typeList: 'search',
            lastItem: 0,
            firstItem: 0,
            vpsOn: 0,
            vpsOff: 0,
            vpsExpire: 0,
            vpsRebuild: 0,
            vpsWaiting: 0,
            vpsProcessing: 0,
            action_sort: "",
            type_sort: "",
            statusParams: ""
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getListService( this.state.statusParams );

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
            errorNotification: this.props.errorNotificationUser,
            messageErrorNotification: this.props.messageErrorNotificationUser,
            successNotification: this.props.successNotificationUser,
            messageSuccessNotification: this.props.messageSuccessNotificationUser,
        })
        if ( this.props.isNotification ) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }

        if (this.props.errorNotificationUser) {
            this.props.updateErrorNotiUser({
                error: false,
                message: ''
            });
        }
        if (this.props.successNotificationUser) {
            this.props.updateSuccessNotiUser({
                success: false,
                message: ''
            });
        }
    }

    componentDidUpdate(prevProps) {
        if ( this.props.statusParams !== prevProps.statusParams ) {
            this.getListService( this.props.statusParams );
        }
    }

    getListService = (statusParams) => {
        this.setState({
            isLoading: true,
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        let data = "?qtt=" + this.state.qtt + "&q=" + this.state.search + "&typeList=" + this.state.typeList
            + "&status=" + statusParams + "&userId=" + this.state.userId
            + "&action_sort=" + this.state.action_sort + "&type_sort=" + this.state.type_sort;

        axios.get( process.env.REACT_APP_API_URL + '/api/admin/proxy/listProxy' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                console.log(ref.data);
                if (ref.data.error === 0) {
                    this.setState({
                        listStatus: ref.data.listStatus,
                        listService: ref.data.content.data,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        currentPage: ref.data.content.current_page,
                        firstItem: ref.data.content.firstItem,
                        lastItem: ref.data.content.lastItem,
                        loadPage: false,
                        isLoading: false,
                        vpsOn: ref.data.listVpsByStatus.on,
                        vpsOff: ref.data.listVpsByStatus.off,
                        vpsExpire: ref.data.listVpsByStatus.expire,
                        vpsRebuild: ref.data.listVpsByStatus.rebuild,
                        vpsWaiting: ref.data.listVpsByStatus.waiting,
                        vpsProcessing: ref.data.listVpsByStatus.progressing
                    })
                } else {
                    if (ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu dịch vụ thất bại',
                })
            })
    }

    changeQtt = async (event) => {
        let value = event.target.value;
        await this.setState({
            qtt: value
        })
        await this.getListService( this.state.statusParams );
    }

    changeStatus = async (event) => {
        let value = event.target.value;
        await this.setState({
            status: value
        })
        await this.getListService( this.state.statusParams );
    }

    search = (event) => {
        // console.log(event.target.value)
        let text  = event.target.value;
        let r = /\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b/; //192.168.1.1
        let r2 = /\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}:\d{1,5}\b/;
        let ip = '';
        let ips = '';
        if ( text.match(r2) ) {
            while (text.match(r2) != null) {
                ip = text.match(r2)[0];
                ips += ip + ',';
                text = text.replace(ip, '');
            }
        }
        if ( text.match(r) ) {
            while (text.match(r) != null) {
                ip = text.match(r)[0];
                ips += ip + ',';
                text = text.replace(ip, '');
            }
        }
        if (typeof(ips) !== 'undefined' && ips !== '') {
            ips = ips.slice(0, -1);
            ips = ips.replace('undefined', '');
            this.setState({
                search: ips,
                typeList: 'searchMulti'
            })
        }
        else {
            ips  = event.target.value;
            this.setState({
                search: ips,
                typeList: 'search'
            })
        }
    }

    submitSearch = (event) => {
        if(event.key === 'Enter') {
            this.getListService( this.state.statusParams );
        }
    }

    btnSearch = () => {
        this.getListService( this.state.statusParams );
    }

    actionSort = async (type) => {
        let type_sort;
        if ( this.state.action_sort.length === 0 ) {
            type_sort = 'DESC';
        }
        else {
            if (this.state.action_sort === 'ASC') {
                type_sort = 'DESC';
            }
            else {
                type_sort = 'ASC';
            }
        }
        // console.log(type_sort)

        await this.setState({
            type_sort: type,
            action_sort: type_sort,
        })
        await this.getListService( this.state.statusParams );
    }

    paginate = () => {
        if (this.state.totalPage > this.state.perPage) {
            return (
                <PaginateComponent
                    total={this.state.totalPage}
                    perPage={this.state.perPage}
                    currentPage={this.state.currentPage}
                    btnPaginate={ (page) => this.btnPaginate(page) }
                />
            );
        }
    }

    btnPaginate = (page) => {
        this.setState({
            isLoading: true
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        // console.log(dataAuth);
        let data = "?qtt=" + this.state.qtt + "&q=" + this.state.search + "&typeList=" + this.state.typeList
            + "&status=" + this.state.statusParams + "&userId=" + this.state.userId
            + "&action_sort=" + this.state.action_sort + "&type_sort=" + this.state.type_sort + "&page=" + page;

        axios.get( process.env.REACT_APP_API_URL + '/api/admin/proxy/listProxy' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listService: ref.data.content.data,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        currentPage: ref.data.content.current_page,
                        isLoading: false,
                        firstItem: ref.data.content.firstItem,
                        lastItem: ref.data.content.lastItem,
                        vpsOn: ref.data.listVpsByStatus.on,
                        vpsOff: ref.data.listVpsByStatus.off,
                        vpsExpire: ref.data.listVpsByStatus.expire,
                        vpsRebuild: ref.data.listVpsByStatus.rebuild,
                        vpsWaiting: ref.data.listVpsByStatus.waiting,
                        vpsProcessing: ref.data.listVpsByStatus.progressing
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            isLoading: false
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isLoading: false
                });
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu khách hàng thất bại',
                })
            })
    }

    checkNotification = () => {
        if ( this.state.isNotification ) {
            return (
                <Alert color="success">
                    { this.state.textNotification }
                </Alert>
            );
        }
        if ( this.state.errorNotification ) {
            return (
                <>
                    <Alert color="danger">
                        { this.state.messageErrorNotification }
                    </Alert>
                </>
            );
        }
        if ( this.state.successNotification ) {
            return (
                <>
                    <Alert color="success">
                        { this.state.messageSuccessNotification }
                    </Alert>
                </>
            );
        }
    }

    screentListService = () => {
        if ( this.state.isLoading ) {
            return (
                <tr>
                    <td className="text-center" colSpan={12}>
                        <Spinner animation="grow" variant="primary" />
                        <Spinner animation="grow" variant="secondary" />
                        <Spinner animation="grow" variant="success" />
                        <Spinner animation="grow" variant="danger" />
                        <Spinner animation="grow" variant="warning" />
                        <Spinner animation="grow" variant="info" />
                    </td>
                </tr>
            );
        } else {
            if ( this.state.listService.length ) {
                return (
                    this.state.listService.map( (service, key) => {
                        return (
                            <ListProxyComponent
                                key={key}
                                service={service}
                                actionKey={key}
                                showModal = { (actionKey, action) => this.showModal(actionKey, action) }
                                checkedService = { (actionKey) => this.checkedService(actionKey) }
                                checkedServiceShiftKey = { (actionKey, value) => this.checkedServiceShiftKey(actionKey, value) }
                            />
                        )
                    })
                )
            } else {
                return (
                    <tr>
                        <td className="text-center text-danger" colSpan="12">
                            Không có VPS trong dữ liệu!
                        </td>
                    </tr>
                )
            }
        }
    }

    checkedService  = (actionKey) => {
        let listService = this.state.listService;
        listService[actionKey].checked = !listService[actionKey].checked;
        this.setState({
            listService: listService,
            checkedStart: actionKey
        })
    }

    checkedServiceShiftKey = (actionKey, value) => {
        if ( this.state.checkedStart !== -1 ) {
            let listService = this.state.listService;
            let n = Math.abs( actionKey - this.state.checkedStart );
            let i = this.state.checkedStart;
            let k = actionKey;
            if ( actionKey < this.state.checkedStart ) {
                i = actionKey;
                k = this.state.checkedStart;
            }
            for (i; i <= n; i++) {
                listService[i].checked = value;
            }
            this.setState({
                listService: listService,
                checkedStart: k
            })
        } else {
            let listService = this.state.listService;
            listService[actionKey].checked = !listService[actionKey].checked;
            this.setState({
                listService: listService,
                checkedStart: actionKey
            })
        }
    }

    checkAll = (event) => {
        // console.log("da den")
        let value = event.target.checked;
        let listService = this.state.listService;
        listService.forEach( service => {
            service.checked = value;
        })
        this.setState({
            checkAll: value,
            listService: listService
        })
    }

    showModal = (key, action) => {
        let titleModal;
        let modalBody;
        if ( action === 'on' ) {
            titleModal = 'Bật VPS';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'off' ) {
            titleModal = 'Tắt VPS';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'restart' ) {
            titleModal = 'Khởi động lại VPS';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'rebuild' ) {
            titleModal = 'Yêu cầu cài đặt lại VPS';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'delete' ) {
            titleModal = 'Xóa VPS';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'expire' ) {
            titleModal = 'Yêu cầu gia hạn VPS';
            modalBody = this.modalBody(key, action);
        }
        this.setState({
            action: action,
            isModal: true,
            btnConfirmDisabled: false,
            contentModal: {
                modalBody: modalBody,
                title: titleModal
            },
            isBtnConfirm: true,
            isSpinner: false,
            actionKey: key
        })
    }

    modalBody = (key, action) => {
        if ( action === 'on' ) {
            return (
                <div className="text-center">
                    Bạn có muốn bật dịch vụ Proxy <b className="text-danger">(ip: { this.state.listService[key].ip })</b> này không?
                </div>
            )
        }
        else if ( action === 'off' ) {
            return (
                <div className="text-center">
                    Bạn có muốn tắt dịch vụ Proxy <b className="text-danger">(ip: { this.state.listService[key].ip })</b> này không?
                </div>
            )
        }
        else if ( action === 'restart' ) {
            return (
                <div className="text-center">
                    Bạn có muốn khởi động lại dịch vụ Proxy <b className="text-danger">(ip: { this.state.listService[key].ip })</b> này không?
                </div>
            )
        }
        else if ( action === 'rebuild' ) {
            return (
                <div className="text-center">
                    Bạn có muốn cài đặt lại dịch vụ Proxy <b className="text-danger">(ip: { this.state.listService[key].ip })</b> này không?
                </div>
            )
        }
        else if ( action === 'delete' ) {
            return (
                <div className="text-center">
                    Bạn có muốn xóa dịch vụ Proxy <b className="text-danger">(ip: { this.state.listService[key].ip })</b> này không?
                </div>
            )
        }
        else if ( action === 'expire' ) {
            return (
                <div className="text-center">
                    Bạn có muốn gia hạn dịch vụ Proxy <b className="text-danger">(ip: { this.state.listService[key].ip })</b> này không?
                </div>
            )
        }
        else if ( action === 'finish_expire' ) {
            return (
                <div className="text-center">
                    Yêu cầu gia hạn VPS thành công. Quý khách vui lòng bấm <a href="/" onClick={ () => this.redirectDetailOrder() }>vào đây </a>
                    để thanh toán hoàn thành quá trình gia hạn.
                </div>
            )
        }
        else if ( action === 'rebuild_chosse_vps' ) {
            return (
                <div className="text-center">
                    <label htmlFor="choose_vps">Chọn hệ điều hành</label>
                    <select className="form-control text-center" name="os" id="choose_vps" onChange={this.changeInput} defaultValue={key[0].id}>
                        {
                            key.map( (os, keyOs) => (
                                <option value={ os.id } key={keyOs}>{ os.os }</option>
                            ))
                        }
                    </select>
                </div>
            )
        }
        else if ( action === 'confirm_expire' ) {
            return (
                <div className="text-center">
                    <label htmlFor="choose_vps">Chọn thời gian gia hạn</label>
                    <select className="form-control text-center" name="billingCycle" id="billingCycle" onChange={this.changeInput} defaultValue={key[0].id}>
                        {
                            key.map( (billingCycle, keyBc) => (
                                <option value={ billingCycle.id } key={keyBc}>{ billingCycle.value }</option>
                            ))
                        }
                    </select>
                </div>
            )
        }
    }

    redirectDetailOrder = () => {
        let link = "/don-dat-hang/" + this.state.orderId + "/chi-tiet-don-dat-hang.html";
        this.hiddenModal();
        window.open(link, '_blank');
    }

    hiddenModal = () => {
        this.setState({
            action: '',
            isModal: false,
        })
    }

    confirmModal = () => {
        let listVps = [];
        if ( this.state.listService.length ) {
            this.state.listService.forEach( (service) => {
                if (service.checked) {
                    listVps.push(service.id);
                }
            })
        }

        this.setState({
            btnConfirmDisabled: true,
            isSpinner: true,
            isBtnConfirm: false,
            alert: {
                error: false,
                message: ''
            }
        })
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let form = {
            vpsId: this.state.listService[ this.state.actionKey ].id,
            action: this.state.action,
            billingCycle: this.state.billingCycle,
            os: this.state.os,
            listVps: listVps
        };
        // console.log( form );
        axios.put( process.env.REACT_APP_API_URL + '/api/admin/proxy/actionService', form,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                this.setState({
                    isSpinner: false,
                });
                if ( ref.data.error > 9000 ) {
                    this.props.logOut();
                }
                else if ( ref.data.error ) {
                    this.setState({
                        contentModal: {
                            modalBody: this.modalBodyConfirm(ref.data.error,ref.data.message),
                            title: this.state.contentModal.title
                        },
                    })
                }
                else {
                    if ( this.state.action === 'rebuild' ) {
                        let titleModal = 'Yêu cầu cài đặt lại Proxy';
                        let modalBody = this.modalBody( ref.data.content , 'rebuild_chosse_vps');
                        this.setState({
                            btnConfirmDisabled: false,
                            contentModal: {
                                modalBody: modalBody,
                                title: titleModal
                            },
                            os: ref.data.content[0].id,
                            isBtnConfirm: true,
                            isSpinner: false,
                            action: 'rebuild_chosse_vps'
                        })
                    }
                    else {
                        if ( !ref.data.error ) {
                            window.scrollTo(0, 0);
                            this.getListService( this.state.statusParams );
                        }
                        this.setState({
                            contentModal: {
                                modalBody: this.modalBodyConfirm(ref.data.error,ref.data.message),
                                title: this.state.contentModal.title
                            },
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isSpinner: false,
                    contentModal: {
                        title: this.state.contentModal.title,
                        modalBody: this.modalBodyConfirm(1, 'Thực hiện hành động không thành công')
                    },
                })
            })
    }

    modalBodyConfirm = (error, message) => {
        if ( error ) {
            return (
                <div className="text-center text-danger">
                    { message }
                </div>
            )
        } else {
            return (
                <div className="text-center text-success">
                    { message }
                </div>
            )
        }
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({
            [name]: value
        });
    }

    showModalAll = (action) => {
        // console.log(action)
        let slc = 0;
        if ( this.state.listService.length ) {
            this.state.listService.forEach( (service) => {
                if (service.checked) {
                    slc++;
                }
            })
        }
        if ( slc ) {
            let titleModal;
            let modalBody;
            if ( action === 'onAll' ) {
                titleModal = 'Bật Proxy';
                modalBody = this.modalBodyAll(action, 0);
            }
            else if ( action === 'offAll' ) {
                titleModal = 'Tắt Proxy';
                modalBody = this.modalBodyAll(action, 0);
            }
            else if ( action === 'restartAll' ) {
                titleModal = 'Khởi động lại Proxy';
                modalBody = this.modalBodyAll(action, 0);
            }
            else if ( action === 'cancelAll' ) {
                titleModal = 'Xóa Proxy';
                modalBody = this.modalBodyAll(action, 0);
            }
            this.setState({
                action: action,
                isModal: true,
                btnConfirmDisabled: false,
                contentModal: {
                    modalBody: modalBody,
                    title: titleModal
                },
                isBtnConfirm: true,
                isSpinner: false,
            })
        }
        else {
            alert("Vui lòng chọn 1 hoặc nhiều Proxy");
        }
    }

    modalBodyAll = (action, key) => {
        if ( action === 'onAll' ) {
            return (
                <div className="text-center" key={key}>
                    Bạn có muốn bật các dịch vụ Proxy này không?
                </div>
            )
        }
        else if ( action === 'offAll' ) {
            return (
                <div className="text-center">
                    Bạn có muốn tắt các dịch vụ Proxy này không?
                </div>
            )
        }
        else if ( action === 'restartAll' ) {
            return (
                <div className="text-center">
                    Bạn có muốn khởi động các dịch vụ Proxy này không?
                </div>
            )
        }
        else if ( action === 'rebuildAll' ) {
            return (
                <div className="text-center">
                    Bạn có muốn cài đặt lại các dịch vụ Proxy này không?
                </div>
            )
        }
        else if ( action === 'cancelAll' ) {
            return (
                <div className="text-center">
                    Bạn có muốn xóa các dịch vụ Proxy này không?
                </div>
            )
        }
    }

    loadQttChecked = () => {
        let n = 0;
        if ( this.state.listService.length ) {
            this.state.listService.forEach( service => {
                if ( service.checked ) {
                    n++;
                }
            })
        }
        return (n);
    }

    changeUser = () => {
        let slc = '';
        let n = 0;
        // console.log(this.state.listService.length)
        if ( this.state.listService.length ) {
            this.state.listService.forEach( (service) => {
                if (service.checked) {
                    slc += service.id + ",";
                    n++;
                }
            })
        }
        // console.log( slc.slice( 0, -1 ) );
        if ( n ) {
            this.props.redirectChangeUser("listId=" + slc.slice( 0, -1 ));
        }
        else {
            alert('Vui lòng chọn một hoặc nhiều Proxy');
        }
    }

    submitSearchUser = (event) => {
        if(event.key === 'Enter') {
            this.setState({
                btnSubmit: true,
            })
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            axios.get( process.env.REACT_APP_API_URL + '/api/admin/vps/searchUser?searchUser=' + this.state.searchUser,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    if ( ref.data.error === 0 ) {
                        this.setState({
                            btnSubmit: true,
                            listUser: ref.data.content,
                        })
                    } else {
                        if ( ref.data.error > 9000 ) {
                            this.props.logOut();
                        }
                        else {
                            this.setState({
                                btnSubmit: true,
                                errorForm: true,
                                messageForm: ref.data.message,
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( () => {
                    this.setState({
                        errorForm: true,
                        btnSubmit: true,
                        messageForm: 'Lấy dữ liệu thất bại',
                    })
                })
        }
    }

    loadSearchUser = () => {
        if ( this.state.listUser.length ) {
            return (
                <ul>
                    {
                        this.state.listUser.map( (user, key) => (
                            <li className={ (user.id === this.state.user_id ? "active" : "") + "choose-user" }
                                key={key}
                                onClick={ () => this.choosseUser( user ) }
                            >
                                { user.name }
                            </li>
                        ))
                    }
                </ul>
            );
        }
        else {
            return (
                <ul>
                    <li className="choose-user text-danger">Khách hàng không tồn tại</li>
                </ul>
            );
        }
    }

    choosseUser = async (user) => {
        await this.setState({
            userId: user.id,
            userChange: user.name,
            listUser: {},
            checkEmail: true,
        })
        await this.getListService( this.state.statusParams );
    }

    changeCheckEmail = () => {
        this.setState({
            checkEmail: false,
        })
    }

    copyProxy = () => {
        let list_vps = "";
        let n = 0;
        if ( this.state.listService.length ) {
            this.state.listService.forEach( (service) => {
                if (service.checked) {
                    list_vps += service.ip + ":" + service.port + "\n";
                    n++;
                }
            })
        }
        if ( n ) {
            this.copyToClipboard(list_vps);
            this.setState({
                textVpsToast: 'Sao chép dịch vụ thành công',
                typeToast: 1
            })
        }
        else {
            alert("Vui lòng chọn một hoặc nhiều dịch vụ");
        }
    }

    // Click vào các button action của Vps
    copyToClipboard = (text) => {
        let sampleTextarea = document.createElement("textarea");
        document.body.appendChild(sampleTextarea);
        sampleTextarea.value = text; //save main text in it
        sampleTextarea.select(); //select textarea contenrs
        document.execCommand("copy");
        document.body.removeChild(sampleTextarea);
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : (
                        <>
                            <Breadcrumb title={"Quản lý dịch vụ Proxy"} page={"Proxy"} icon={<FaCloud className="breadcrumb-icon"/>} />
                            <div className="col-md-12 mt-2 mb-2">
                                <div className="container-info-vps row">
                                    <h5 className="m-0 mr-3">Thông tin chi tiết Proxy: </h5>
                                    {
                                        this.state.vpsOn ? (
                                            <>
                                                <span className="mr-2">
                                                    <strong>Đang bật:</strong> { this.state.vpsOn } Proxy -
                                                    <Link to={"/admin/proxy/on/danh-sach-proxy-theo-trang-thai.html"} className="ml-1">
                                                        Chi tiết
                                                    </Link>
                                                </span>
                                            </>
                                        ) : (
                                            <></>
                                        )
                                    }
                                    {
                                        this.state.vpsOff ? (
                                            <>
                                                <span className="mr-2">
                                                    <strong>Đang tắt:</strong> { this.state.vpsOff } Proxy -
                                                    <Link to={"/admin/proxy/off/danh-sach-proxy-theo-trang-thai.html"} className="ml-1">
                                                        Chi tiết
                                                    </Link>
                                                </span>
                                            </>
                                        ) : (
                                            <></>
                                        )
                                    }
                                    {
                                        this.state.vpsExpire ? (
                                            <>
                                                <span className="mr-2">
                                                    <strong>Đã hết hạn:</strong> { this.state.vpsExpire } Proxy -
                                                    <Link to={"/admin/proxy/expire/danh-sach-proxy-theo-trang-thai.html"} className="ml-1">
                                                        Chi tiết
                                                    </Link>
                                                </span>
                                            </>
                                        ) : (
                                            <></>
                                        )
                                    }
                                    {
                                        this.state.vpsWaiting ? (
                                            <>
                                                <span className="mr-2">
                                                    <strong>Chờ tạo:</strong> { this.state.vpsWaiting } Proxy -
                                                    <Link to={"/admin/proxy/waiting/danh-sach-proxy-theo-trang-thai.html"} className="ml-1">
                                                        Chi tiết
                                                    </Link>
                                                </span>
                                            </>
                                        ) : (
                                            <></>
                                        )
                                    }
                                    {
                                        this.state.vpsProcessing ? (
                                            <>
                                                <span className="mr-2">
                                                    <strong>Đang tạo:</strong> { this.state.vpsProcessing } Proxy -
                                                    <Link to={"/admin/proxy/progressing/danh-sach-proxy-theo-trang-thai.html"} className="ml-1">
                                                        Chi tiết
                                                    </Link>
                                                </span>
                                            </>
                                        ) : (
                                            <></>
                                        )
                                    }
                                    {
                                        this.state.vpsRebuild ? (
                                            <>
                                                <span className="mr-2">
                                                    <strong>Đang cài lại:</strong> { this.state.vpsRebuild } Proxy -
                                                    <Link to={"/admin/proxy/rebuild/danh-sach-proxy-theo-trang-thai.html"} className="ml-1">
                                                        Chi tiết
                                                    </Link>
                                                </span>
                                            </>
                                        ) : (
                                            <></>
                                        )
                                    }
                                </div>
                            </div>
                            <Card>
                                <CardBody>
                                    <div className="dataTables_wrapper dt-bootstrap">
                                        {
                                            this.state.error ? (
                                                <div className="col-md-12">
                                                    <Alert color="danger">
                                                        {this.state.messageError}
                                                    </Alert>
                                                </div>
                                            ) : (
                                                <div className="list-group-email row">
                                                    <div className="col-md-3 mb-3 form-inline">
                                                        <select className="form-control form-control-sm mr-1" value={this.state.qtt} onChange={ this.changeQtt }>
                                                            <option value="10">10</option>
                                                            <option value="20">20</option>
                                                            <option value="30">30</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                            <option value="200">200</option>
                                                        </select>
                                                        <UncontrolledButtonDropdown>
                                                            <DropdownToggle caret size="sm">
                                                                { this.state.btn_all }
                                                            </DropdownToggle>
                                                            <DropdownMenu>
                                                                <DropdownItem onClick={ () => this.copyProxy() }>Sao chép dịch vụ</DropdownItem>
                                                                <DropdownItem onClick={ () => this.changeUser() }>Chuyển khách hàng</DropdownItem>
                                                                <DropdownItem onClick={ () => this.showModalAll('cancelAll') }>Xóa</DropdownItem>
                                                            </DropdownMenu>
                                                        </UncontrolledButtonDropdown>
                                                    </div>
                                                    <div className="col-md-3 mb-3">
                                                    </div>
                                                    <div className="search-user col-md-3 mb-3">
                                                        {
                                                            this.state.checkEmail ? (
                                                                <input type="text" id="user" className="form-control"
                                                                       placeholder="Tìm kiếm khách hàng"
                                                                       name="searchUser"
                                                                       value={ this.state.userChange }
                                                                       onClick={ () => this.changeCheckEmail() }
                                                                />
                                                            ) : (
                                                                <input type="text" id="user" className="form-control"
                                                                       placeholder="Tìm kiếm khách hàng"
                                                                       onChange={ this.changeInput }
                                                                       name="searchUser"
                                                                       defaultValue={ this.state.userChange }
                                                                       onKeyPress={ this.submitSearchUser }
                                                                />
                                                            )
                                                        }
                                                        {
                                                            this.state.listUser.length ? (
                                                                <div className="list-search-user">
                                                                    {
                                                                        this.loadSearchUser()
                                                                    }
                                                                </div>
                                                            ) : (
                                                                <></>
                                                            )
                                                        }
                                                    </div>
                                                    <div className="col-md-3">
                                                        <InputGroup>
                                                            <Input placeholder="Tìm kiếm dịch vụ" onChange={ this.search } onKeyPress={ this.submitSearch } value={ this.state.search } />
                                                            <InputGroupAddon addonType="prepend">
                                                                <Button onClick={ () => this.btnSearch() }> <FaSearch /> </Button>
                                                            </InputGroupAddon>
                                                        </InputGroup>
                                                    </div>
                                                    <div className="col-md-12 text-primary mb-3">
                                                        <b>
                                                            Hiển thị từ { this.state.firstItem } - { this.state.lastItem } / { this.state.totalPage }
                                                        </b>
                                                        <br/>
                                                        <b>
                                                            Đã chọn:
                                                            <span className="qtt-checkbox"> { this.loadQttChecked() }</span> / <span
                                                            className="total-item">{ this.state.listService.length }</span>
                                                        </b>
                                                    </div>
                                                    <div className="col-md-12">
                                                        {
                                                            this.checkNotification()
                                                        }
                                                    </div>
                                                    <div className="col col-md-12 table-responsive">
                                                        <Table className="table table-sm table-bordered table-hover rounded table-list">
                                                            <thead className="primary">
                                                            <tr>
                                                                <th width="3%"><input type="checkbox" defaultValue={false} onChange={ this.checkAll } /></th>
                                                                <th width="10%">Khách hàng</th>
                                                                <th width="10%">IP</th>
                                                                <th width="7%">Port</th>
                                                                <th width="10%">Tài khoản<br />Mật khẩu</th>
                                                                <th width="7%">Loại</th>
                                                                <th
                                                                    width="9%"
                                                                    onClick={ () => this.actionSort('created_at') }
                                                                    className={`
                                                                            sorting 
                                                                            ${this.state.action_sort === '' && this.state.type_sort === 'created_at' ? 'order_by' : ''}
                                                                            ${this.state.action_sort === 'DESC' && this.state.type_sort === 'created_at' ? 'sorting_desc' : ''}
                                                                            ${this.state.action_sort === 'ASC' && this.state.type_sort === 'created_at' ? 'sorting_asc' : ''}
                                                                        `}
                                                                >
                                                                    Ngày tạo
                                                                </th>
                                                                <th
                                                                    width="9%"
                                                                    onClick={ () => this.actionSort('next_due_date') }
                                                                    className={`
                                                                            sorting 
                                                                            ${this.state.action_sort === '' && this.state.type_sort === 'next_due_date' ? 'order_by' : ''}
                                                                            ${this.state.action_sort === 'DESC' && this.state.type_sort === 'next_due_date' ? 'sorting_desc' : ''}
                                                                            ${this.state.action_sort === 'ASC' && this.state.type_sort === 'next_due_date' ? 'sorting_asc' : ''}
                                                                        `}
                                                                >
                                                                    Ngày kết thúc
                                                                </th>
                                                                <th width="7%">Tổng thời gian thuê</th>
                                                                <th width="7%">Chu kỳ thanh toán</th>
                                                                <th
                                                                    width="7%"
                                                                    onClick={ () => this.actionSort('amount') }
                                                                    className={`
                                                                            sorting 
                                                                            ${this.state.action_sort === '' && this.state.type_sort === 'amount' ? 'order_by' : ''}
                                                                            ${this.state.action_sort === 'DESC' && this.state.type_sort === 'amount' ? 'sorting_desc' : ''}
                                                                            ${this.state.action_sort === 'ASC' && this.state.type_sort === 'amount' ? 'sorting_asc' : ''}
                                                                        `}
                                                                >
                                                                    Chi phí
                                                                </th>
                                                                <th width="7%">Trạng thái</th>
                                                                <th width="7%">Hành động</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                                { this.screentListService() }
                                                            </tbody>
                                                            <tfoot className="mt-3">
                                                                <tr>
                                                                    <td colSpan={15}>
                                                                        { this.paginate() }
                                                                    </td>
                                                                </tr>
                                                            </tfoot>
                                                        </Table>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                </CardBody>
                            </Card>
                            <ModalComponent
                                isModal={ this.state.isModal }
                                content={this.state.contentModal}
                                isBtnConfirm={ this.state.isBtnConfirm }
                                isSpinner={ this.state.isSpinner }
                                btnConfirmDisabled={ this.state.btnConfirmDisabled }
                                hiddenModal={ () => this.hiddenModal() }
                                confirmModal={ () => this.confirmModal() }
                                alert={ this.state.alert }
                            />
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
        errorNotificationUser: state.notificationUser.errorNotificationUser,
        messageErrorNotificationUser: state.notificationUser.messageErrorNotificationUser,
        successNotificationUser: state.notificationUser.successNotificationUser,
        messageSuccessNotificationUser: state.notificationUser.messageSuccessNotificationUser,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'AdminProxyByStatus' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
        updateSuccessNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
        updateErrorNotiUser: (item) => {
            dispatch(({ type : 'updateErrorNotiUser', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ListProxyByStatus);